import React, { useState, useEffect } from 'react';
import LotoreyaController from '../../../../api/lotoreya/LotoreyaController';
import './LotoreyaIstekleri.css';
import moment from 'moment';
import ElanController from '../../../../api/elan/ElanController';
import UserController from '../../../../api/user/UserController';
import { useNavigate } from 'react-router-dom'; // Yönləndirmə üçün useNavigate

const LotoreyaIstekleri = () => {
    const [lotoreyas, setLotoreyas] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate(); // useNavigate hookunu istifadə edirik

    useEffect(() => {
        const loadLotoreyas = async () => {
            try {
                const all = await LotoreyaController.getAllLotoreyas();
                const filtered = all.filter(l => l.isAccept === false);

                // Elanları yüklə (əlavə məlumat üçün, məsələn şəkil, başlıq və s.)
                for (let lotoreya of filtered) {
                    const elan = await ElanController.getElanById(lotoreya.elanId);
                    lotoreya.elan = elan; // əlavə məlumatı daxil et

                    const user = await UserController.getUserById(lotoreya.userId);
                    lotoreya.user = user; // əlavə məlumatı daxil et
                }

                setLotoreyas(filtered);
            } catch (error) {
                console.error('Lotoreya istəkləri yüklənərkən xəta:', error);
            } finally {
                setIsLoading(false);
            }
        };

        loadLotoreyas();
    }, []);

    const handleAccept = async (lotoreyaId, biletPrice, lotoreyaDate) => {
        try {
            await LotoreyaController.updateLotoreya(lotoreyaId, {
                isAccept: true,
                biletPrice: parseFloat(biletPrice),
                lotoreyaDate: lotoreyaDate
            });

            alert('✅ Lotoreya təsdiqləndi!');
            // Yenidən yüklə
            setLotoreyas(prev => prev.filter(l => l.id !== lotoreyaId));
        } catch (error) {
            console.error('Lotoreyanı təsdiqləyərkən xəta:', error);
            alert('Xəta baş verdi, yenidən cəhd edin.');
        }
    };

    const handleBack = () => {
        navigate(-1); // Geri getmək üçün bu funksiyanı istifadə edirik
    };

    return (
        <div className="lotoreya-istekleri-container">
            <h2>Lotoreya İstəkləri</h2>
            <button onClick={handleBack} className="back-button">
                Geri
            </button>

            {isLoading ? (
                <div className="loading">Yüklənir...</div>
            ) : lotoreyas.length === 0 ? (
                <div className="no-requests">Hazırda təsdiqlənməmiş lotoreya yoxdur.</div>
            ) : (
                <div className="lotoreya-list">
                    {lotoreyas.map((lotoreya) => (
                        <div key={lotoreya.id} className="lotoreya-card">
                            <img src={lotoreya.elan?.image} alt={lotoreya.elan?.title} className="lotoreya-image" />

                            {/* Elana Bax düyməsi - şəkilin altında */}
                            <div style={{ marginTop: '10px', textAlign: 'center' }}>
                                <button
                                    onClick={() => window.open(`/private/elan/${lotoreya.elan?.id}`, '_blank')}
                                    className="view-elan-btn"
                                >
                                    Elana Bax
                                </button>
                            </div>

                            {/* Lotoreya info */}
                            <div className="lotoreya-info">
                                <h3>{lotoreya.elan?.title}</h3>
                                <p><strong>Əlavə edilib:</strong> {moment(lotoreya.createdAt).locale('az').format('LL, HH:mm')}</p>
                                <p><strong>Gerçək Qiymət:</strong> {lotoreya.elan?.price} AZN</p>
                            </div>

                            {/* Lotoreya actions */}
                            <div className="lotoreya-actions">
                                <label>
                                    Bilet Qiyməti (₼):
                                    <input type="number" step="0.01" min="1" id={`biletPrice-${lotoreya.id}`} required />
                                </label>

                                <label>
                                    Lotoreya Tarixi:
                                    <input type="date" id={`lotoreyaDate-${lotoreya.id}`} required />
                                </label>

                                <button
                                    className="accept-btn"
                                    onClick={() => {
                                        const biletPrice = document.getElementById(`biletPrice-${lotoreya.id}`).value;
                                        const lotoreyaDate = document.getElementById(`lotoreyaDate-${lotoreya.id}`).value;

                                        if (!biletPrice || !lotoreyaDate) {
                                            alert('Zəhmət olmasa bilet qiyməti və tarix doldurun.');
                                            return;
                                        }

                                        handleAccept(lotoreya.id, biletPrice, lotoreyaDate);
                                    }}
                                >
                                    Təsdiqlə
                                </button>

                                {/* Sorğunu Ləğv Et düyməsi */}
                                <button
                                    className="delete-btn"
                                    onClick={async () => {
                                        if (window.confirm('Sorğunu ləğv etmək istəyirsiniz?')) {
                                            try {
                                                await LotoreyaController.deleteLotoreyaById(lotoreya.id);
                                                alert('❌ Sorğu ləğv edildi!');
                                                // Listdən sil
                                                setLotoreyas(prev => prev.filter(l => l.id !== lotoreya.id));
                                            } catch (error) {
                                                console.error('Sorğunu silərkən xəta:', error);
                                                alert('Xəta baş verdi, yenidən cəhd edin.');
                                            }
                                        }
                                    }}
                                >
                                    Sorğunu Ləğv Et
                                </button>

                            </div>
                        </div>

                    ))}
                </div>
            )}
        </div>
    );
};

export default LotoreyaIstekleri;

